import {
  DRG_CODE_CHARACTER_LIMIT,
  ICD_CODE_CHARACTER_LIMIT,
} from "core/schemas/shared";
import { margin, padding } from "ds_legacy/materials/metrics";
import {
  Section,
  SectionRow,
  TextAreaWithLabel,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SectionOne = () => {
  const translations = useTranslations();

  return (
    <Section title={translations.patientForms.drvMedicalForm.sectionOne.title}>
      <SectionRow customPadding={padding(1, 0, 0)}>
        <TextAreaWithLabel
          elementName="main_diagnosis"
          isBold
          label={
            translations.patientForms.drvMedicalForm.sectionOne
              .descriptionDiagnosis
          }
          sx={{ margin: margin(0) }}
        />
      </SectionRow>
      <SectionRow>
        <TextInputWithLabel
          characterLimit={ICD_CODE_CHARACTER_LIMIT}
          elementName="icd_code_1_code"
          isBold
          isLarge
          label={
            translations.patientForms.drvMedicalForm.sectionOne.diagnosisIcd
          }
        />
        <TextInputWithLabel
          characterLimit={DRG_CODE_CHARACTER_LIMIT}
          elementName="drg_code"
          isBold
          isLarge
          label={translations.patientForms.drvMedicalForm.sectionOne.drgGroup}
        />
      </SectionRow>
    </Section>
  );
};
